import { setCurrencyCookie } from '@/actions/villages';
import { DropdownItem } from '@/components/NewHeader/DropdownItem';
import { useRedirectFromLangChange } from '@/components/NewHeader/useRedirectFromLangChange';
import { useCurrency } from '@/contexts/currencyContext';
import { useTranslation } from '@/contexts/dictionaryContext';
import { useLocale } from '@/hooks/useLocale';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

type Option = {
  value: string;
  flag?: string;
  label: string;
};

const currencyOptions = [
  {
    label: 'Euro',
    value: 'eur',
    flag: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/admin/flags/EU.png',
  },
  {
    label: 'Dollar',
    value: 'usd',
    flag: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/admin/flags/US.png',
  },
  {
    label: 'Pound',
    value: 'gbp',
    flag: 'https://villatravellers-prod.s3.eu-west-2.amazonaws.com/assets/images/admin/flags/GB.png',
  },
];

const langOptions = [
  { label: 'English', value: 'en' },
  { label: 'Italiano', value: 'it' },
  { label: 'Deutsch', value: 'de' },
  { label: 'Français', value: 'fr' },
];

export function HeaderDropdowns() {
  const lang = useLocale();
  const { currency } = useCurrency();
  const [selectedCurrency, setSelectedCurrency] = useState(currency.value);
  const { header } = useTranslation();
  const { push, refresh } = useRouter();
  const { getRedirectUrl } = useRedirectFromLangChange();

  useEffect(() => {
    setSelectedCurrency(currency.value);
  }, [currency]);

  async function handleSetCurrency(option: Option) {
    setSelectedCurrency(option.value);
    await setCurrencyCookie(option.value);
    refresh();
    window.location.reload();
  }

  function handleSetLang(option: Option) {
    push(getRedirectUrl(option.value));
  }

  return (
    <>
      <DropdownItem
        title={header.select.currencyModalTitle}
        options={currencyOptions}
        value={selectedCurrency}
        setValue={handleSetCurrency}
      />

      <DropdownItem
        title={header.select.languageModalTitle}
        options={langOptions}
        value={lang}
        setValue={handleSetLang}
      />
    </>
  );
}
